/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCheckouts200ResponseAllOfData } from './GetCheckouts200ResponseAllOfData';
import {
    GetCheckouts200ResponseAllOfDataFromJSON,
    GetCheckouts200ResponseAllOfDataFromJSONTyped,
    GetCheckouts200ResponseAllOfDataToJSON,
} from './GetCheckouts200ResponseAllOfData';
import type { ResponseSuccessWithPagingAllOfMeta } from './ResponseSuccessWithPagingAllOfMeta';
import {
    ResponseSuccessWithPagingAllOfMetaFromJSON,
    ResponseSuccessWithPagingAllOfMetaFromJSONTyped,
    ResponseSuccessWithPagingAllOfMetaToJSON,
} from './ResponseSuccessWithPagingAllOfMeta';

/**
 * 
 * @export
 * @interface GetCheckouts200Response
 */
export interface GetCheckouts200Response {
    /**
     * 
     * @type {GetCheckouts200ResponseAllOfData}
     * @memberof GetCheckouts200Response
     */
    data: GetCheckouts200ResponseAllOfData;
    /**
     * 
     * @type {ResponseSuccessWithPagingAllOfMeta}
     * @memberof GetCheckouts200Response
     */
    meta: ResponseSuccessWithPagingAllOfMeta;
}

/**
 * Check if a given object implements the GetCheckouts200Response interface.
 */
export function instanceOfGetCheckouts200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetCheckouts200ResponseFromJSON(json: any): GetCheckouts200Response {
    return GetCheckouts200ResponseFromJSONTyped(json, false);
}

export function GetCheckouts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCheckouts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCheckouts200ResponseAllOfDataFromJSON(json['data']),
        'meta': ResponseSuccessWithPagingAllOfMetaFromJSON(json['meta']),
    };
}

export function GetCheckouts200ResponseToJSON(value?: GetCheckouts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCheckouts200ResponseAllOfDataToJSON(value.data),
        'meta': ResponseSuccessWithPagingAllOfMetaToJSON(value.meta),
    };
}

